import { useEffect, useState } from 'react';
import { marketplaceaccountApi, type MarketplaceAccount, type MarketplaceCapability } from '../../api/marketplaceaccount';

export function MappingsPage() {
  const [accounts, setAccounts] = useState<MarketplaceAccount[]>([]);
  const [selected, setSelected] = useState('');
  const [capabilities, setCapabilities] = useState<MarketplaceCapability[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void marketplaceaccountApi.list().then(setAccounts).catch((e) => setError(String(e)));
  }, []);

  useEffect(() => {
    if (!selected) return;
    void marketplaceaccountApi.capabilities(selected).then(setCapabilities).catch((e) => setError(String(e)));
  }, [selected]);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold">Mappings & Capabilities</h1>
      <p className="mt-1 text-sm text-slate-600">Warehouse, currency, price book mappings and marketplace capabilities.</p>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <select className="mt-4 w-full max-w-md rounded border p-2" value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">Select account</option>
        {accounts.map((a) => <option key={a.id} value={a.id}>{a.display_name}</option>)}
      </select>
      {capabilities.length > 0 && (
        <ul className="mt-6 space-y-2">
          {capabilities.map((c) => (
            <li key={c.id} className="flex items-center justify-between rounded border bg-white p-3 text-sm">
              <span>{c.capability_type}</span>
              <span className={c.enabled ? 'text-green-600' : 'text-slate-400'}>{c.enabled ? 'Enabled' : 'Disabled'}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
